import { Locale } from "date-fns";

import { createSafeContext } from "utils/createSafeContext";

type LocaleContextType = {
  locale: string;
  setLocale: (locale: string) => void;
  syncLocale: (locale: string) => void;
  dateFnsLocale: Locale;
  setDateFnsLocale: React.Dispatch<React.SetStateAction<Locale>>;
};

// Use the simplified function to create context and hook
export const [LocaleContext, useLocaleContext] =
  createSafeContext<LocaleContextType>("LocaleContext");
